import { render, staticRenderFns } from "./imgRecycleBin.vue?vue&type=template&id=16ae11f6&scoped=true"
import script from "./imgRecycleBin.vue?vue&type=script&lang=js"
export * from "./imgRecycleBin.vue?vue&type=script&lang=js"
import style0 from "./imgRecycleBin.vue?vue&type=style&index=0&id=16ae11f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ae11f6",
  null
  
)

export default component.exports